module.exports = __webpack_public_path__ + "static/media/combined.a36bd630.ogg";